export enum ASSETS {
  Image = "image",
  Map = "map"
}
